module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAWCAYAAAA1vze2AAABXklEQVRIib3WsWoVQRTG8d/uXSJCjCAKESHVLUQIYmchBCs7UQiW9pIX8D0CyQOksvYBUqcIsROLa2shkUgMRJLcY7FD2Ez2kpvR6wcDO9/sOf+d2ZmzW0WETB/wBt/zgSl0Dx/xsmtWGWSAU6xjswDyFu9xE8fnbkTkbRQR8z3+tG2Uew2W8Cgxb+AW1vAJ1TVn8jDFr+JX8r5UEfENiwVLM61+1AlwjA2MZgC5U6eLz9ol2poB5LCKiCPMYRtPcHcWkAPc/seJL0Bq1Ffe9peaOeC/QZoJ/hiXitoUqvQ8eDMB9FzZmXmAnZxRRU8ZxgIOCyANTvrMd3ja6b/CEHsFkCGOtOX+d/J2+6ro14h4UViBn6X4C37+kubSbE4LZiHFNbLDnUMGhclz1RM72i1Y4Wdh8oNOnnPl2zdwH8vYz2++QoHH2m087g7k33jaH4kVnLn+gRxoz8nrbuwfKkHfr4LIhb8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fax.png
// module id = vBzX
// module chunks = 36